'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('../constants');

var _constants2 = _interopRequireDefault(_constants);

var Row = function Row(props) {
    var gutter = props.gutter;
    var className = props.className;
    var style = props.style;

    var rest = _objectWithoutProperties(props, ['gutter', 'className', 'style']);

    var rowStyle = {
        display: 'flex',
        flexWrap: 'wrap',
        msFlexWrap: 'wrap',
        WebkitFlexWrap: 'wrap',
        marginLeft: gutter / -2,
        marginRight: gutter / -2
    };

    return _react2['default'].createElement('div', _extends({}, rest, { style: _extends(rowStyle, style), className: (0, _classnames2['default'])('Row', className) }));
};

Row.propTypes = {
    children: _propTypes2['default'].node.isRequired,
    className: _propTypes2['default'].string,
    gutter: _propTypes2['default'].number,
    style: _propTypes2['default'].object
};

Row.defaultProps = {
    gutter: _constants2['default'].width.gutter
};

module.exports = Row;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Row.js
// module id = 978
// module chunks = 0 1